






























import Component, { mixins } from 'vue-class-component';
import BaseFormMixin from '@/mixins/base-form-mixin';
import RuleFormTab1 from './rule-form-tab1.vue';
import RuleFormTab2 from './rule-form-tab2.vue';
import RuleFormTab3 from './rule-form-tab3.vue';
import RuleFormTab4 from './rule-form-tab4.vue';
import RuleServices, { RuleDto, RuleActionDto } from '@/services/rule';
import CategoryServices from '@/services/category';

import { Watch } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import { checkCode } from '@/libs/util';
@Component({
  components: { RuleFormTab1, RuleFormTab2, RuleFormTab3, RuleFormTab4 }
})
export default class RuleForm extends mixins(BaseFormMixin) {
  breadList = [{ name: '创建决策' }];
  ruleSrv = new RuleServices();
  categorySrv = new CategoryServices();
  baseJobInfo: any = {
    cronExpression: '0 0 2 * * ?',
    jobMode: 0,
    jobConfig: {
      rate: 0,
      runDateFormat: '',
      runDateStr: ''
    }
  };
  ruleDefinition: any = {
    logicalOperator: '&&',
    ruleConditionList: []
  };
  formData: RuleDto = {
    ...this.baseJobInfo,
    ruleDefinition: this.ruleDefinition,
    ruleActions: []
  };
  // 同步方式
  id: any = 0;
  categoryId: any = 0;
  keepalive: boolean = true;

  initFormData() {
    this.formData = { ...this.baseJobInfo, rulePriority: 1, ruleDefinition: this.ruleDefinition, ruleActions: [] };
    this.current = 0;
  }

  created() {
    this.id = this.$route.query.id;
    this.categoryId = this.$route.query.categoryId;
    this.initFormData();
  }

  activated() {
    this.onIdChange();
  }

  refreshKeepalive() {
    if (!this.$route.query.keepalive) {
      this.keepalive = false;
      this.$router.push({
        query: { ...this.$route.query, keepalive: 'true' }
      });
    } else {
      this.keepalive = true;
    }
  }

  @Watch('$route')
  onRouteChange(to: any, from: any) {
    this.id = this.$route.query.id;
    this.categoryId = this.$route.query.categoryId;
    this.cache = this.isNeedCache(from, to);
    this.onIdChange();
  }

  @Watch('id')
  async onIdChange() {
    this.id = this.$route.query.id;
    let path = this.$route.path;
    if (path == '/decision/rule/add') {
      this.refreshKeepalive();
      if (this.keepalive && this.cache) return false;

      this.initFormData();

      let category = await this.categorySrv.getInfo(this.categoryId);
      this.breadList = [{ name: category.categoryName }, { name: '创建决策' }];
    }
    if (path == '/decision/rule/edit') {
      if ((!this.id || this.id == this.formData.id) && this.cache) return false;
      this.spinning = true;
      let res = await this.ruleSrv.getInfo(this.id);
      this.spinning = false;
      if (!res) return false;
      this.formData = res;
      this.formData.jobConfig = JSON.parse(this.formData.jobConfig);
      this.formData.ruleDefinition = JSON.parse(this.formData.ruleDefinition);
      this.current = 0;

      this.breadList = [{ name: res.ruleCategoryName || '' }, { name: res.ruleName || '' }, { name: '编辑决策' }];
    }
  }

  async next() {
    if (this.current === 0) {
      const must: { field: 'ruleCode' | 'ruleName' | 'rulePriority'; msessage: string }[] = [
        { field: 'ruleCode', msessage: '决策编码不能为空' },
        { field: 'ruleName', msessage: '决策名称不能为空' },
        { field: 'rulePriority', msessage: '决策优先级不能为空' }
      ];
      for (let val of must) {
        if (!this.formData[val.field]) {
          this.$message.error(val.msessage);
          return false;
        }
      }
      if (!checkCode(this.formData.ruleCode)) {
        this.$message.error('编码只能包含英文字母、数字、下划线');
        return false;
      }
      if (!this.id) {
        let code = 'RULE_' + this.formData.ruleCode;
        let exist = await this.ruleSrv.getList({ ruleCode_eq: code });
        if (exist.length > 0) {
          this.$message.error(`编码[${code}]已经存在`);
          return false;
        }
      }
    }
    if (this.current === 1) {
    }
    if (this.current === 2) {
      const must: { field: 'ruleFirstLevel' | 'ruleSecondLevel' | 'ruleOwnerPlate' | 'ruleOwnerDept' | 'ruleOwnerUid'; msessage: string }[] = [
        { field: 'ruleFirstLevel', msessage: '决策大类不能为空' },
        { field: 'ruleSecondLevel', msessage: '决策中类不能为空' },
        { field: 'ruleOwnerPlate', msessage: '管理板块不能为空' },
        { field: 'ruleOwnerDept', msessage: '管理部门不能为空' },
        { field: 'ruleOwnerUid', msessage: '必须搜索并选择决策负责人' }
      ];
      for (let val of must) {
        if (!this.formData[val.field]) {
          this.$message.error(val.msessage);
          return false;
        }
      }
    }
    this.current++;
  }

  loading: boolean = false;
  async confirm() {
    this.loading = true;
    let ruleSetCode: any = this.$route.query.ruleSetCode;
    let ruleSetId: any = this.$route.query.ruleSetId;

    if (!ruleSetCode || !ruleSetId) {
      this.$message.error('参数错误：没有指定决策集');
      return false;
    }
    if (this.id) {
      let res = await this.ruleSrv.update({ ...this.formData });
      if (res) {
        this.replaceUrlWithOutConfirm(`/decision/rule/detail?id=${this.id}&ruleSetCode=${ruleSetCode}&ruleSetId=${ruleSetId}`);
        this.initFormData();
      }
    } else {
      let categoryId: number | boolean = typeof this.$route.query.categoryId === 'string' ? parseInt(this.$route.query.categoryId) : false;
      if (!categoryId) {
        this.$message.error('参数错误：没有指定目录');
        return false;
      }
      this.formData.ruleCategoryId = categoryId;
      this.formData.ruleSetCode = ruleSetCode;
      let res = await this.ruleSrv.add({ ...this.formData });
      if (res) {
        this.replaceUrlWithOutConfirm(`/decision/rule/detail?id=${res.id}&ruleSetCode=${ruleSetCode}&ruleSetId=${ruleSetId}`);
        this.initFormData();
      }
    }
    this.loading = false;
    this.HANDLE_RELOAD_RULE_MENU();
  }
  @Mutation HANDLE_RELOAD_RULE_MENU: any;
}
